var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[(_vm.loaded)?_c('div',[_c('div',{staticClass:"tableContainer"},[_c('UsersTable')],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }